import templateUrl from './editor.html';
import clone from 'lodash/clone';
import reduce from 'lodash/reduce';
import Jodit from './jodit.min';

export const editorComponent = {
	bindings: {
		details: '<',
		disableButtons: '<',
		showFooterButtons: '@',
		pageTitle: '@',
		getEditorDetails: '&',
		editorFieldError: '@',
		onCancel: '&',
		onSubmit: '&'
	},

	templateUrl,

	controller: class EditorComponent {
		constructor($parse, $timeout, ModalService, ApiService) {
			'ngInject';

			this.$parse = $parse;
			this.$timeout = $timeout;
			this.modalService = ModalService;
			this.apiService = ApiService;
		}

		$onInit() {
			this._editorFieldError = this.$parse(this.editorFieldError || 'false')(false);;
			this._showFooterButtons = this.$parse(this.showFooterButtons || 'true')(true);
			this.details = this.details || this._getBlankObject();

			this.pageTitle = this.pageTitle || 'Description';

			// Editor custo buttons for image and video uploading
			this.editor = new Jodit("#editor", {
				buttons: this._getListOfEditorButtons(),
				buttonsMD: this._getListOfEditorButtons(),
				buttonsSM: this._getListOfEditorButtons(),
				buttonsXS: this._getListOfEditorButtons(),
				extraButtons: [this._getEditorExtraButtonForImageConfigObject(), this._getEditorExtraButtonForVideoConfigObject()],
				toolbarSticky: true,
				askBeforePasteHTML: false,
				askBeforePasteFromWord: false,
				preset: "inline"
			});
			this.editor.setEditorValue(this.details.description);

			this.editorWindow = angular.element(this.editor.editor);
			this.editorWindow.bind('blur', _ => {
				//get Data on blur event
				this._getEditorDetails();
			});
		}

		_getListOfEditorButtons() {
			return ['paragraph', 'bold', 'italic', 'underline', 'link', 'ul', 'ol', 'undo', 'redo'];
		}

		_getEditorExtraButtonForImageConfigObject() {
			return {
				name: 'insertImage',
				tooltip: 'Insert Image',
				iconURL: '/./images/image-editor-icon.png',
				exec: (editor) => {
					const parentDivId = this._getRandomId();
					editor.selection.insertHTML(`<span id='${parentDivId}'></span>`);
					this._openEditorImageModal(parentDivId);
				}
			};
		}

		_getEditorExtraButtonForVideoConfigObject() {
			return {
				name: 'insertVideo',
				tooltip: 'Insert Video',
				iconURL: '/./images/video.png',
				exec: (editor) => {
					const parentDivId = this._getRandomId();
					editor.selection.insertHTML(`<div id='${parentDivId}'></div>`);
					this._openEditorVideoModal(parentDivId);
				}
			};
		}

		_openEditorImageModal(parentDivId) {
			this.modalService.open({
				component: 'editorImageUploadModal',
				backdrop: 'static',
				keyboard: false,
				details: {
					data: clone(this.details),
					getSelectedImage: image => {
						const imageSrc = this.apiService.getResourceUrl(`files/images/${image}`);
						const parentElement = document.getElementById(parentDivId);
						parentElement.innerHTML = `<img src='${imageSrc}' id='${image}' class="${image}" style="border: 1px solid #ccc;margin:5px;">`;
					},
					getDeletedImageUuids: deletedUuids => {
						deletedUuids.map(({ uuid }) => {
							this._deleteElementFromDOM(uuid);
						});
					},
					getAllUpdatedContentImages: images => this.details.images = images
				}
			});
		}

		_openEditorVideoModal(parentDivId) {
			this.modalService.open({
				component: 'editorVideoLinkModal',
				backdrop: 'static',
				keyboard: false,
				details: {
					data: clone(this.details),
					getSelectedLink: link => {
						const parentElement = document.getElementById(parentDivId);
						parentElement.innerHTML = `<div id="${link}" class="editor-video ${link}" align='center'><iframe src="${link}" frameborder="0" allowfullscreen=""></iframe></div>`;
					},
					getDeletedLinks: deletedLinks => {
						deletedLinks.map(({ link }) => {
							this._deleteElementFromDOM(link);
						});
					},
					getAllUpdatedContentVideos: videos => this.details.videos = videos
				}
			});
		}

		_deleteElementFromDOM(element) {
			let elements = document.getElementsByClassName(element);
			while (elements.length > 0) {
				elements[0].parentNode.removeChild(elements[0]);
			}
		}

		_getEditorDetails() {
			this.details.description = this.editor.editor.innerHTML;
			this.$timeout(_ => this._editorFieldError = this._validateEditorContent());
			this.getEditorDetails({
				$event: this.details
			});
		}

		_getBlankObject() {
			return {
				description: "",
				images: [],
				videos: []
			};
		}

		_getRandomId(idLength = 5) {
			const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
			return reduce([...Array(idLength).keys()], (id, index) => {
				return id += possible.charAt(Math.floor(Math.random() * possible.length));
			}, 0);
		}

		_validateEditorContent() {
			return this.editor.editor.innerHTML.length > 0 ? false : true;
		}

		_onSubmit() {
			this._editorFieldError = this._validateEditorContent();
			this.details.description = this.editor.editor.innerHTML;
			if (!this._editorFieldError) {
				this.onSubmit();
			}
		}

		$onChanges(changes) {
			if (changes && changes.editorFieldError) {
				this._editorFieldError = this.$parse(changes.editorFieldError.currentValue || 'true')(true);
			}
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/components/editor/editor.component.js